export default "__VITE_ASSET__BvzoxgFs__"